import { useState } from "react";
import { Container, Modal } from "react-bootstrap";

import styles from "./OrgUploadModal.module.scss";


import BannerPicker from "../../../util/graphic-picker/banner-picker";
import Close from "../../../Assets/close.svg";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";
import ConsoleLocalStorage from "../../../storage/storage";
import { useUpdateOrg } from "../../../hooks/DevConsoleHooks";

const OrgUploadModal = ({
  showOrgUploadModal,
  setShowOrgUploadModal,
  isCover,
}) => {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const handleClose = () => {
    setError("");
    setShowOrgUploadModal(false)};
  const { mutate } = useUpdateOrg(
    ConsoleLocalStorage.getOrganization().id,
    setShowOrgUploadModal
  );

  const handleSubmit = async () => {
    if(url.length<=0) return setError("Upload image to save");
    const data = isCover
      ? { banner: url, adminId: ConsoleLocalStorage.getUser().id }
      : { logo: url, adminId: ConsoleLocalStorage.getUser().id };
    mutate(data);
  };

  return (
    <>
      <Container>
        <Modal
          show={showOrgUploadModal}
          onHide={handleClose}
          centered
          contentClassName={styles.orgUpload}
          dialogClassName={styles.mah_modal}
        >
          <Modal.Header className={styles.title_modal_header}>
            <Modal.Title>
              <span
                style={{
                  fontFamily: "JioType-Medium",
                  fontSize: "medium",
                  marginBottom: "3em",
                }}
              >
                Upload Organization {isCover ? "Cover Image" : "Logo"}
              </span>
            </Modal.Title>
            <img
              onClick={() => handleClose()}
              src={Close}
              height="14"
              width="14"
              style={{ marginTop: "10px" }}
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>
          <Modal.Body>
            <div className={styles.orgUploadBody}>
              <div className={styles.orgUpload_body_container}>
                <BannerPicker
                  height="200px"
                  width="100%"
                  fileTypeCheck={".jpg, .jpeg, .png"}
                  onComplete={(data) => {
                    setUrl(data.path);
                  }}
                  dimensionCheck={isCover?{ width: 1280, height: 256 }:{ width: 256, height: 256 }}
                />
                <span style={{ color: "red" }} className="file-upload-error">
                  {error}
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1em",
              }}
              className=""
            >
              <SecondaryButton
                style={{ marginRight: "1rem" }}
                onClick={() => handleClose()}
              >
                Cancel
              </SecondaryButton>
              <PrimaryButton onClick={handleSubmit}>Save</PrimaryButton>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default OrgUploadModal;
